import { useNavigate, useParams } from "react-router-dom";
import { useQueryClient } from "react-query";

export default function useGoNext(){

    const {course, tab} = useParams();
    const navigate = useNavigate();

    const queryClient = useQueryClient();

    const data = queryClient.getQueryData(course);

    const sections = data.chapters.reduce((a,b) => a.concat(b.sections), []);

    const index = sections.findIndex(s => s.id === tab) + 1;

    const nextSection = sections[index] || sections[index - 1];

    const fn = () => navigate(`/study/${course}/${nextSection.id}`);
    
    return fn;
}